import ModalActions from '@components/modal/ModalActions';
import ModalContent from '@components/modal/ModalContent';
import ModalTitle from '@components/modal/ModalTitle';
import { LockPersonOutlined, SupportAgent } from '@mui/icons-material';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { type FC } from 'react';

const Unauthorized: FC<{ onClose?: () => void }> = ({ onClose }) => {
  return (
    <>
      <ModalTitle onClose={onClose} title="Acceso restringido"></ModalTitle>
      <ModalContent>
        <Stack spacing={3} alignItems="center" textAlign="center">
          {/* Icono con fondo suave para que no parezca un error fatal */}
          <Box
            sx={{
              backgroundColor: 'action.hover',
              borderRadius: '50%',
              p: 2,
              display: 'inline-flex',
            }}
          >
            <LockPersonOutlined sx={{ fontSize: 50, color: 'text.secondary' }} />
          </Box>

          <Box>
            <Typography variant="h5" fontWeight="700" gutterBottom>
              Acceso Restringido
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Tu perfil actual no cuenta con los permisos necesarios para acceder a este módulo.
            </Typography>
          </Box>

          <Box
            sx={{
              width: '100%',
              p: 2,
              borderRadius: 2,
              opacity: 0.9,
              color: 'text.secondary',
            }}
          >
            <Typography variant="body2">
              Si necesitas habilitar esta sección, por favor contacta a nuestro equipo de soporte.
            </Typography>
          </Box>
        </Stack>
      </ModalContent>
      <ModalActions onClose={onClose}></ModalActions>
    </>
  );
};
export { Unauthorized };
